import React, { useState, useEffect } from "react";
import useSendEvents from "../hooks/useSendEvents";
import { useLocation, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const CarouselSolutions = ({ data }) => {
  const isBgWhite = data.bgColor === "white";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { handleEvent, handleEventWithCallBackRedirect } = useSendEvents();
  const location = useLocation();
  const navigate = useNavigate();

  const handleDispatch = (href, event) => {
    if (location.pathname.split("/")[2] === "sector") {
      handleEventWithCallBackRedirect(
        () =>
          handleEvent({
            event: "select_content",
            action_type: "click on cta",
            selection_name: "discover more",
            module_type: "product list slide",
            page_category: "sectors page",
            value: event,
          }),
        href
      );
    } else {
      navigate(href);
    }
  };

  return (
    <div className="w-full mt-10 2xl:p-8">
      <div className="flex flex-col text-center xs:px-4">
        <h1 className="text-5xl xs:text-start">{data.title}</h1>
        <p className="text-xl xs:text-start xs:pt-4">{data.text}</p>
      </div>

      <section className="mx-auto max-w-7xl mt-10 overflow-hidden relative">
        <Swiper
          modules={[Pagination]}
          slidesPerView={isMobile ? 1 : 3}
          spaceBetween={30}
          pagination={{ clickable: true }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="w-full"
        >
          {data.solution.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="grid grid-rows-2 xs:flex xs:flex-col w-full">
                <div className={isBgWhite ? "bg-white" : "bg-[#DCEBF0]"}>
                  <div className="h-96 px-4 py-10">
                    <a href={item.link}>
                      {item.image && (
                        <img
                          src={item.image}
                          alt={item.title}
                          className="w-full h-full object-contain"
                        />
                      )}
                    </a>
                  </div>
                </div>
                <div className="grid grid-rows-2 justify-between px-4 bg-[#FBFBFB]">
                  <div className="flex flex-col h-48">
                    <div className="flex flex-row gap-x-4 px-10 xl:px-2 py-2 xs:px-2 text-[#23779a]">
                      <p>{item.textOne}</p>
                      <p>{item.textTwo}</p>
                    </div>
                    <h3 className="text-3xl text-[#EC0000]">
                      {item.titleOne}{" "}
                      <span className="text-black">{item.titleTwo}</span>
                    </h3>
                    <h3 className="text-3xl text-black">{item.text}</h3>
                  </div>
                  <div className="flex mb-14 items-end gap-4">
                    {item.actionSecondary && (
                      <button
                        onClick={() => handleDispatch(item.link, item.event)}
                        className="action-secondary"
                      >
                        {item.actionSecondary}
                      </button>
                    )}
                    {item.actionPrimary && (
                      <button
                        onClick={() =>
                          handleDispatch(
                            `${item.link}?source=${encodeURIComponent(
                              item.source
                            )}`,
                            item.event
                          )
                        }
                        className="action-primary"
                      >
                        {item.actionPrimary}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}

          {/* ✅ Paginación incluida dentro del Swiper */}
          <div className="swiper-pagination !relative !mt-6 !mb-2 !z-10 flex justify-center" />
        </Swiper>

        {/* Estilos personalizados para los bullets */}
        <style>{`
          .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            margin: 0 6px;
            opacity: 0.5;
            background-color: black;
            border-radius: 100%;
            transition: all 0.3s ease;
          }
          .swiper-pagination-bullet-active {
            opacity: 1;
            background-color: #EC0000 !important;
          }
        `}</style>
      </section>
    </div>
  );
};

export default CarouselSolutions;
